import ErrorService from "@/services/ErrorService.js"
import { ERROR } from "@/constants"

const errorMixin = {
  methods: {
    handleError(error) {
      this.notifications = [
        ...this.notifications,
        ...ErrorService.handle(error),
      ]
    },
  },
}

const gridRowErrorMixin = {
  emits: ["add-notification"],
  methods: {
    handleError(error) {
      this.$emit("add-notification", {
        id: Date.now() + Math.random() * 10000,
        type: ERROR,
        message: error.message,
      })
    },
  },
}

export { errorMixin, gridRowErrorMixin }
